import { createAction, props } from '@ngrx/store';

import { EmailTemplate } from '@shared/models';

export const rejectCandidateEmailTemplatesGet = createAction('[Email Templates] Get Rejected Candidate Email Templates');

export const rejectCandidateEmailTemplatesGetSuccess = createAction(
  '[Email Templates] Get Rejecte Candidate Email Templates Success',
  props<{ emailTemplates: EmailTemplate[] }>(),
);

export const rejectCandidateEmailTemplatesGetFailure = createAction(
  '[Email Templates] Get Rejecte Candidate Email Templates Failure',
  props<{ error: any }>(),
);
